import { request } from 'app/functions/request';
import { route } from 'app/routes/web';
import { setMessage } from 'app/actions/setMessage';
import { ParseError } from 'app/functions/error-parse';

export const admin_products_request_invalid = 'admin_products_request_invalid';
export const admin_products_request_send = 'admin_products_request_send';
export const admin_products_request_valid = 'admin_products_request_valid';

export function AdminProductsRequestInvalid() {
    return {
        type: admin_products_request_invalid,
    };
}

export function AdminProductsRequestSend() {
    return {
        type: admin_products_request_send,
    };
}

export function AdminProductsRequestValid(data) {
    return {
        type: admin_products_request_valid,
        data,
    };
}

export function fetchAdminProducts(data, valid) {
    return function (dispatch) {
        dispatch(AdminProductsRequestSend());
        request(
            route.shop.adminProducts,
            data,
            (data) => {
                if (data.success && data.data_response.success) {
                    if (typeof valid === 'function') valid(data.data_response);
                    dispatch(AdminProductsRequestValid(data.data_response));
                } else {
                    if (data.msg || data.data_response?.msg) {
                        dispatch(
                            setMessage(
                                ParseError(data.msg || data.data_response.msg),
                                'error'
                            )
                        );
                    } else {
                        dispatch(setMessage('Неверные данные', 'error'));
                    }
                    dispatch(AdminProductsRequestInvalid());
                }
            },
            (error) => {
                dispatch(AdminProductsRequestInvalid());
            },
            (url) => `${url}/${data?.id}`
        );
    };
}
